import type { IconData } from '@stacksjs/iconify-core'

export const handLove: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 6.1h1.53v13.71h-1.53Zm-1.52 13.71h1.52v4.58h-1.52Zm-1.52-15.23h3.04V6.1h-3.04Zm0 22.85h-13.72v-3.04H9.9v3.04H8.375V32h19.81v-4.57h-1.52v-3.04h-1.52Zm0 3.05H22.1v-1.52h3.05Zm-1.53-15.24h1.53v1.53h-1.53Zm-4.57 0h1.53v1.53h-1.53Zm-4.57 0h1.52v1.53h-1.52Zm0-1.52h1.52v-3.05h3.05v3.05h1.53v-3.05h3.04v3.05h1.53V6.1h-1.53v3.05h-7.62V1.53h-1.52zM11.425 0h3.05v1.53h-3.05Zm-3.05 21.34h1.53v3.05h-1.53Zm1.53-6.1v1.53h1.52V1.53h-1.52v12.19h-1.53v1.52zm-3.05 4.57h1.52v1.53h-1.52Zm0-7.62h1.52v1.53h-1.52Zm-1.52 6.1h1.52v1.52h-1.52Zm-1.53-7.62h3.05v1.52h-3.05Zm0 6.1h1.53v1.52h-1.53Zm-1.52-4.58h1.52v4.58h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handLove
